const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]')
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();
        setTimeout(() => {
            let headerHeight=document.querySelector('.site-header').offsetHeight;
            
            if (document.querySelector('.collection-sticky-menu')) {
                document.querySelector('.collection-sticky-menu').style.top=`${headerHeight-1}px`;
            }
            
        }, 1000);

        document.querySelectorAll('[data-collection-scrollbar] [data-single-type]').forEach((ele)=>{
            ele.addEventListener('click',(event)=>{
                event.preventDefault();
                document.querySelectorAll('[data-collection-scrollbar] [data-single-type].active').forEach((item) => {
                   item.classList.remove('active');
                });
                ele.classList.add('active');
                let target=ele.getAttribute('href');
                Utility.scrollToOffsetHeight(target);
            })
            
        })
        document.querySelectorAll('.section-faq custom-accordion p,span.faq_question').forEach((ele)=>{
              ele.addEventListener('click',(event)=>{
                  event.preventDefault();
                  event.stopPropagation();
                  console.log(event.target.closest('a'),'cscss')
                  event.target.closest('a').click();
              })
            })
        this._bindEvents();
        
    }
    _bindEvents(){

        const target_links=document.querySelectorAll('.target-link');
        document.addEventListener('scroll',(event)=>{
            target_links.forEach((ele)=>{
                let flag=Utility.in_Viewport(ele);
                if (flag) {
                    let id=ele.getAttribute('id');
                    document.querySelector(`[data-single-type].active`)?.classList.remove('active');
                    document.querySelector(`[href="#${id}"]`)?.classList.add('active');
                    let offsetLeft=document.querySelector(`[href="#${id}"]`).offsetLeft;
                    document.querySelector('[data-collection-scrollbar]').scrollLeft=offsetLeft-150;
                }
            })
        })

        // Manage Size Filter
        this.allSizeElements = document.querySelectorAll('[data-size-filter]');
        this.allSizeElements.forEach(ele => ele.addEventListener('click', this._applyFilter.bind(this)));
    }

   async _applyFilter(event){
        event.stopImmediatePropagation();
        let element=event.target.closest('[data-size-filter]');
        let size=element.getAttribute('data-size-filter');
        let name=element.getAttribute('data-value');
        document.querySelector('[data-size-filter].active')?.classList.remove('active')
        element.classList.add('active');

        document.querySelectorAll('[data-product-grid]').forEach(ele => {
            if(ele.classList.contains(`V-${size}`) || size == 'clear-filter'){
                ele.classList.remove('d-none');
            }else{
                ele.classList.add('d-none');
            }
        });
    }

    // Read More and Read Less
    readMore(){
        if(selectors.readMoreBtn){
            selectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
                if(readMoreEle){ 
                    if(selectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 